module.exports = __webpack_public_path__ + "assets/media/card-img-product-demo.21cdc9a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/card-img-product-demo.jpg
// module id = 3250
// module chunks = 0